var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAvailable)?_c('ejs-button',{attrs:{"cssClass":"e-link"},nativeOn:{"click":function($event){return _vm.clientBtnClick(_vm.tradingGroupId)}}},[_vm._v(_vm._s(_vm.tradingGroupName))]):_c('span',[_vm._v(_vm._s(_vm.tradingGroupName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }